module.exports = __webpack_public_path__ + "img/react-native.d83b5d91.svg";